import React, { memo } from 'react';
import { classNames } from '../../utils/classNames';

export const FormSection = memo(function FormSection({
	title,
	description,
	required = false,
	children,
	className,
	contentClassName,
}) {
	return (
		<section className={classNames('flex flex-col gap-2', className)}>
			{title ? (
				<div className='flex flex-col gap-0.5'>
					<h2 className='text-sm font-semibold text-zinc-800'>
						{title}
						{required ? <span className='text-rose-500'> *</span> : null}
					</h2>
					{description ? (
						<p className='text-xs text-zinc-500'>{description}</p>
					) : null}
				</div>
			) : null}
			<div className={contentClassName}>{children}</div>
		</section>
	);
});

export default FormSection;